import { FC } from 'react';
import { SortableTable } from '../../molecules';
import { Action, Label, TableRow } from '../../atoms';
import { LandscapeBuyerRelationType } from '../../../store/landscapeAPI/landscape/landscape-buyer-relation-type';

interface TableItem {
  id: string;
  landscapeName: string;
  relationType: LandscapeBuyerRelationType;
}

interface OrganizationLandscapeOrganismProps {
  data: TableItem[];
  handleDelete: (id: string) => void;
}

const OrganizationLandscapesOrganism: FC<
  OrganizationLandscapeOrganismProps
> = ({ data, handleDelete }) => {
  return (
    <SortableTable
      data={data}
      columns={[
        { label: 'Landscape', key: 'landscapeName' },
        { label: 'Relation type', key: 'relationType' },
      ]}
      showEditButtonHeader={false}
      renderRow={(item) => (
        <TableRow key={item.id}>
          <Label content={item.landscapeName} />
          <Label content={item.relationType} />
          <Action
            type="delete"
            size="sm"
            onClick={() => handleDelete(item.id)}
          />
        </TableRow>
      )}
    />
  );
};

export default OrganizationLandscapesOrganism;
